<template>
  <div v-if="room">
    <p class="is-size-5">Leaderboard 🏆</p>
    <table class="table is-bordered is-striped is-hoverable is-narrow is-fullwidth mt-1">
      <tbody>
        <tr v-for="(user, index) in orderedUsers" v-bind:key="user.userId">
          <th>{{index + 1}}</th>
          <td style="text-align: left;">
            {{user.username}}
            <span class="is-size-7 ml-2">{{user.position | positionToString }}</span>
          </td>
          <td>
            {{user.wins}}
            <span v-if="user.wins != 1">wins</span>
            <span v-else>win</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "LeaderboardComponent",
  props: {
    room: Object,
  },
  computed: {
    orderedUsers: function () {
      var users = [];
      if (this.room && this.room.users) {
        var temp = [...this.room.users];
        temp = temp.sort((a, b) =>
          b.wins > a.wins ? 1 : a.wins > b.wins ? -1 : 0
        );
        users = temp;
      }
      return users;
    },
  },
};
</script>

<style>
</style>